import type { Directive } from 'vue'

import { useTourStore } from '@/stores/tour'

/** Registers the element as the anchor for the tour step with this key: `v-coach="'shell.nav'"`. */
export const vCoach: Directive<HTMLElement, string> = {
  mounted(element, binding) {
    if (!binding.value) return
    useTourStore().registerTarget(binding.value, element)
  },
  updated(element, binding) {
    if (binding.value === binding.oldValue) return
    const store = useTourStore()
    if (binding.oldValue) store.unregisterTarget(binding.oldValue, element)
    if (binding.value) store.registerTarget(binding.value, element)
  },
  unmounted(element, binding) {
    if (!binding.value) return
    useTourStore().unregisterTarget(binding.value, element)
  },
}
